module.exports = __webpack_public_path__ + "static/media/LK_White_Event.8d095691.svg";